import { css } from '@emotion/react'

export const createDefaultsAndCustomTypedCSS = (csses?: {
  defaultsCSS?: CSS
  customCSS?: CSS
}): {
  readonly defaultsCSS: CSS
  customCSS: CSS
} => ({ customCSS: css``, defaultsCSS: css``, ...csses })
